import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import { useYouScreen } from "../YouScreenContext";
import RemindersNotifications from "../sections/RemindersNotifications";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "NotificationsSettings">;

export default function NotificationsSettingsScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { dispatch, notificationPreferences, notificationPreferencesStatus } =
    useYouScreen();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.notifications")}
      onBack={handleBack}
    >
      <RemindersNotifications
        notificationPreferences={notificationPreferences}
        notificationPreferencesStatus={notificationPreferencesStatus}
        dispatch={dispatch}
      />
    </YouDetailScreenLayout>
  );
}
